import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import image001 from '../assetes/images/settings/image001.png';
import image002 from '../assetes/images/settings/image002.png';
import image003 from '../assetes/images/settings/image003.png';
import image004 from '../assetes/images/settings/image004.png';
import image005 from '../assetes/images/settings/image005.png';
import image006 from '../assetes/images/settings/image006.png';
import image007 from '../assetes/images/settings/image007.png';
import Searchbar from '../component/SearchBar'

export default function AccountSetting() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">

                        <div className='dashboard-page-wrap document-page-wrap '>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Account Settings</h1>
                                <p className='header-para'>The Account Settings page allows users to manage their personal account information, including email, username, region, time zone, language preferences, and more. Below is a breakdown of the available fields and their functionalities.</p>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Accessing Account Settings
                                    </div>
                                    <div className="card-body">
                                        <p> To access the Account Settings page:</p>
                                        <ul>
                                            <img src={image001} alt="fullview" className='img-fluid pb-10' />
                                            <li>Navigate to the Settings menu in the sidebar.</li>
                                            <li>Click on Account Settings under the GENERAL section.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Available Fields & Functions
                                    </div>
                                    <div className="card-body">
                                        <p><b>General Information</b> </p>
                                        <ul>
                                            <img src={image002} alt="fields" className=' w-60 pt-10 pb-20' />
                                            <li>Email: Displays the registered email of the user. It may or may not be editable based on permissions.</li>
                                            <li>User Name: The display name of the user, which can be modified.</li>
                                        </ul>

                                        <p> <b>Localization Settings</b> </p>
                                        <ul>
                                            <li><b>Region:</b>  Select the geographical region from a dropdown list. <br />
                                                <img src={image003} alt="fields" className='pt-20  pb-20' />
                                            </li>
                                            <li> <b>Country:</b> Choose a country from the available options. <br />
                                                <img src={image004} alt="fields" className='pt-20  pb-20' />
                                            </li>
                                            <li><b>Time Zone:</b> Set the preferred time zone based on the user's location. <br />
                                                <img src={image005} alt="fields" className='pt-20  pb-20' />
                                            </li>

                                        </ul>

                                        <p> <b>Saving Changes</b> </p>
                                        <ul>
                                            <img src={image007} alt="button" className='pt-10  pb-20' />
                                            <li>Once modifications are made, click the "Save Changes" button to update your account settings.</li>
                                            <li>If any mandatory fields are missing or invalid, an error message will appear.</li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>












                </div>
            </div>
        </>
    )
}
